import NewJobCard from "../../../components/NewJob/Cards/card";
import classes from "./newJob.module.css";
import Img1 from "../../../assets/images/NewJob/gig.svg";
import Img2 from "../../../assets/images/NewJob/job.svg";

const NewJob = () => {
  return (
    <div>
      <h3 className={`flex ${classes.title}`}>Add a New Job/Gig</h3>
      <div className={`flex ${classes.cards}`}>
        <NewJobCard
          img={Img1}
          text="a gig is an offer between one to six months"
          header="Gig"
          move="gig"
        />
        <NewJobCard
          img={Img2}
          text="a job is an offer that is 6 months and above"
          header="Job"
          move="job"
        />
      </div>
    </div>
  );
};

export default NewJob;
